var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-bottom-sheet',{attrs:{"content-class":_vm.$props.contentClass,"persistent":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_c('v-sheet',[_c('header',[_vm._t("header")],2),_c('section',[_vm._t("body")],2),_c('footer',[_vm._t("footer")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }